import Navigation from '../../../components/layout/Navigation';
import Footer from '../../../components/layout/Footer';
import Hero from '../../../components/ui/Hero';
import Section from '../../../components/ui/Section';
import FeatureGrid from '../../../components/ui/FeatureGrid';
import ProcessTimeline from '../../../components/ui/ProcessTimeline';
import CTA from '../../../components/ui/CTA';

export default function ThreeDPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <Hero 
        title={<>Bringing Concepts to <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-purple-300 bg-clip-text text-transparent">Vibrant, Tangible Life</span></>}
        description="Transform imagination into reality with cutting-edge 3D multi-color development and precision printing."
        bgImage="/assets/advanced-multicolor-3d-printer.png"
        primaryBtn={{ text: "Bring Idea to Life", link: "/contact", icon: "ri-3d-view-line" }}
        secondaryBtn={{ text: "View 3D Portfolio", link: "/work", icon: "ri-gallery-line" }}
      />

      <Section>
        <FeatureGrid 
          title="Specialized Solutions for a Multi-Dimensional World"
          subtitle="Explore how our expertise can transform your concepts into tangible, vibrant realities."
          items={[
            { title: '3D Modeling', description: 'Detailed models for prototyping & visualization.', icon: 'ri-cube-line', color: 'from-purple-500 to-blue-500' },
            { title: 'Multi-Colour Printing', description: 'Vibrant physical prototypes with high fidelity.', icon: 'ri-printer-line', color: 'from-purple-500 to-blue-500' },
            { title: 'Industrial Design', description: 'Functional prototypes bridging concept to product.', icon: 'ri-tools-line', color: 'from-purple-500 to-blue-500' },
            { title: 'Visualization', description: 'Photorealistic renderings and animations.', icon: 'ri-building-line', color: 'from-purple-500 to-blue-500' }
          ]}
          columns={2}
        />
      </Section>

      <Section className="bg-gray-900">
        <ProcessTimeline 
          title="From Digital Blueprint to Physical Masterpiece"
          subtitle="We combine meticulous 3D modeling expertise with the latest advancements in multi-color printing."
          steps={[
            { title: 'Idea', description: 'Discovery & concept.', icon: 'ri-lightbulb-line', color: 'from-yellow-400 to-orange-500' },
            { title: 'Software', description: '3D Modeling & design.', icon: 'ri-computer-line', color: 'from-blue-400 to-purple-500' },
            { title: 'Refining', description: 'Detail optimization.', icon: 'ri-settings-3-line', color: 'from-green-400 to-blue-500' },
            { title: 'Printing', description: 'Multi-color production.', icon: 'ri-printer-line', color: 'from-purple-400 to-pink-500' },
            { title: 'Object', description: 'Final realization.', icon: 'ri-cube-line', color: 'from-pink-400 to-red-500' }
          ]}
        />
      </Section>

      <CTA 
        title={<>Ready to See Your Ideas in a <span className="bg-gradient-to-r from-purple-300 to-pink-300 bg-clip-text text-transparent">New Dimension?</span></>}
        description="Partner with Hash Adz to transform your concepts into stunning, tangible realities."
        primaryBtn={{ text: "Request Quote", link: "/contact" }}
        secondaryBtn={{ text: "View Portfolio", link: "/work" }}
        stats={[
          { number: '500+', label: '3D Models' },
          { number: '200+', label: 'Prototypes' },
          { number: '98%', label: 'Satisfaction' },
          { number: '24/7', label: 'Support' }
        ]}
      />

      <Footer />
    </div>
  );
}